import {
  WorkspaceLimitChip,
  WorkspaceLimitDot,
  useLimitState,
} from '@/features/spend-limits';
import { useWorkspace } from '@/features/workspaces';
import { WorkspaceAccessChip } from './WorkspaceAccessChip';

/**
 * What a phone's top bar has no room for (spec 260), at the top of the
 * navigation sheet: the workspace's spend state and the reader's standing in
 * it, the same chips a wider screen shows in the bar. Nothing at all when
 * neither has anything to say, which is almost always.
 */
export function PhoneNavStatus({ workspaceId }: { workspaceId: string }) {
  const { data: workspace } = useWorkspace(workspaceId);
  const limits = useLimitState(workspaceId);
  const name = workspace?.name ?? 'This workspace';
  return (
    <div className="bg-sidebar border-sidebar-border flex flex-wrap items-center gap-2 border-r px-3 pt-3 empty:hidden">
      <WorkspaceLimitChip
        workspaceId={workspaceId}
        workspaceName={name}
        state={limits.workspace}
      />
      <WorkspaceAccessChip workspaceId={workspaceId} workspaceName={name} />
    </div>
  );
}

/** The limit's dot on a phone's menu button, while the chip is in the sheet. */
export function PhoneMenuMark({ workspaceId }: { workspaceId: string }) {
  const limits = useLimitState(workspaceId);
  return <WorkspaceLimitDot state={limits.workspace} />;
}
